export type NAV_MODE = {
  key: string
  name: string
  index: number
}

export type NAV_VALUE = {
  [key: string]: NAV_MODE
}

export const NAV_VALUES: NAV_VALUE = {
  VIEW_MODE: { key: 'VIEW_MODE', name: 'view-mode', index: 0 },
  TICKET_MODE: { key: 'TICKET_MODE', name: 'ticket-mode', index: 1 },
  TICKET_HISTORY_MODE: { key: 'TICKET_HISTORY_MODE', name: 'ticket-history-mode', index: 2 },
  ANALYTICS_MODE: { key: 'ANALYTICS_MODE', name: 'analytics-mode', index: 3 },
}
